import React, { useContext } from 'react';

import assetAccountContext from '../../context/assetAccountContext';
import BackgroundBar from '../styled/BackgroundBar';
import NumericChange from '../shared/NumericChange';

import styles from './GainLossBar.module.scss';
import { formatCurrencyChange } from '../../utils/numberFormatter';

const GainLossBar: React.FC = () => {
  const account = useContext(assetAccountContext).selectedAccount;
  if (!account) {
    return null;
  }

  const {
    realizedGainLoss: { shortTermChange, longTermChange, netChange }
  } = account;

  return (
    <BackgroundBar
      className={styles['gain-loss-bar']}
      contentClassName={styles['content-container']}>
      <div className={styles['gain-loss-title']}>
        Year-to-Date Realized Gain/Loss
      </div>
      <div className={styles['value-container']}>
        <div className={styles['value-title']}>Short-term</div>
        <div className={styles['value']}>
          <NumericChange
            formatFunction={formatCurrencyChange}
            value={shortTermChange}
          />
        </div>
      </div>
      <div className={styles['value-container']}>
        <div className={styles['value-title']}>Long-term</div>
        <div className={styles['value']}>
          <NumericChange
            formatFunction={formatCurrencyChange}
            value={longTermChange}
          />
        </div>
      </div>
      <div className={styles['value-container']}>
        <div className={styles['value-title']}>Net</div>
        <div className={styles['value']}>
          <NumericChange
            formatFunction={formatCurrencyChange}
            value={netChange}
          />
        </div>
      </div>
    </BackgroundBar>
  );
};

export default GainLossBar;
